import BannerOverlay from "../components/BannerOverlay";
import { TeamContent } from "../components/pages/team/Training";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";

const Training = () => {
    return (
        <div className="m-0 p-0" style={{ background: "var(--brand-black)" }}>
            <Header />
            <BannerOverlay
                imageUrl="https://ik.imagekit.io/dnddecpho/dndream/D&D_Website_WebBanner_1920x500px_PC3_cFhwO1chk.jpg?updatedAt=1731826250725"
                title=""
            />
            <TeamContent />
            <Footer />
        </div>
    );
};

export default Training;
